// src/DeleteBin.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var DeleteBin_default = createIcon({
  displayName: "DeleteBin",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10 2L9 3H5C4.448 3 4 3.448 4 4C4 4.552 4.448 5 5 5H19C19.552 5 20 4.552 20 4C20 3.448 19.552 3 19 3H15L14 2H10ZM5 7V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V7H5ZM9.41016 10.4141C9.66541 10.4141 9.92073 10.5106 10.1152 10.7051L12 12.5898L13.8848 10.7051C14.2738 10.3161 14.9059 10.3161 15.2949 10.7051C15.6839 11.0941 15.6839 11.7262 15.2949 12.1152L13.4102 14L15.2949 15.8848C15.6839 16.2738 15.6839 16.9059 15.2949 17.2949C14.9059 17.6839 14.2738 17.6839 13.8848 17.2949L12 15.4102L10.1152 17.2949C9.72623 17.6839 9.09408 17.6839 8.70508 17.2949C8.31608 16.9059 8.31608 16.2738 8.70508 15.8848L10.5898 14L8.70508 12.1152C8.31608 11.7262 8.31608 11.0941 8.70508 10.7051C8.89958 10.5106 9.15491 10.4141 9.41016 10.4141Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  DeleteBin_default
};
